import React from 'react';
import { FunctionalSelect, SelectItem } from '../ui/Select';
import { BASELINE_OPTIONS } from '../../services/offerStudioService';

export default function BaselineSelect({ value, onChange, available, offerCategory }) {
  const options = BASELINE_OPTIONS.filter((o) => !available || available.includes(o.id));
  return (
    <FunctionalSelect label="Compare converters with" value={value} onValueChange={onChange} className="w-full sm:w-64">
      {options.map((o) => (
        <SelectItem key={o.id} value={o.id}>
          {o.id === 'vertical' && offerCategory ? `${offerCategory} converters` : o.label}
        </SelectItem>
      ))}
    </FunctionalSelect>
  );
}
